// extracted by css-extract-rspack-plugin
export default {"switch":"switch-zV4tdb","switchBase":"switchBase-LUEpc8","switchTrack":"switchTrack-lGggd3"};